(() => {
  const WebFont = require('webfontloader');
  WebFont.load({
    google: {
      families: ['Nunito+Sans:400,500,700:latin-ext']
    }
  });
})();
